<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.mini_game_template") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="templateCode" :disabled="loading" :placeholder="$t('message.search_by_template_code')" @enter="getDefaultTemplateList(true)" size="sm")

              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getDefaultTemplateList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addDefaultTemplate type="button" variant="info" size="sm" :disabled="loading")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_mini_game_template") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.template_code')") {{ $t('ui.template_code') }}
                        th(width="18%")
                          span(:title="$t('ui.template_name')") {{ $t('ui.template_name') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="defaultTemplateList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in defaultTemplateList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.template_code") {{ item.template_code }}
                        td
                          span(:title="item.template_name") {{ item.template_name }}
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="item.updated_by") {{ item.updated_by ? item.updated_by : "-" }}
                          br
                          span(:title="$moment(item.updated_on).format('YYYY-MM-DD, HH:mm:ss')") {{ item.updated_on ? $moment(item.updated_on).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                        td.actions.text-center.align-middle
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              v-if="isAdmin && isEditAccess"
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              v-if="isAdmin && isEditAccess"
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

      adddefaulttemplate(@clicked="addDefaultTemplate" @failed="handleFailed")
      editdefaulttemplate(ref="editdefaulttemplate" :item="editSelectedDefaultTemplate" @clicked="afterEdit" @failed="handleFailed")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import adddefaulttemplate from "@/components/content/defaultTemplate/addDefaultTemplate.vue";
import editdefaulttemplate from "@/components/content/defaultTemplate/editDefaultTemplate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    adddefaulttemplate,
    editdefaulttemplate,
  },
  data: () => ({
    loading: false,
    editSelectedDefaultTemplate: null,
    defaultTemplateList: [],
    templateCode: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_defaulttemplate");
    }
  },
  mounted: function() {
    this.getDefaultTemplateList(true);
  },
  methods: {
    onEdit(e) {
      this.editSelectedDefaultTemplate = e;
      this.$refs.editdefaulttemplate.$refs.editDefaultTemplate.show();
    },
    afterEdit() {
      this.getDefaultTemplateList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_mini_game_template"), this.$t("message.success"), "success");
    },
    onDelete:function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.delete"),
          text: this.$t("message.delete_mini_game_template_confirm", { minigametemplate: e.template_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(e);
          }
        });
    },
    confirmDelete: function(e) {
      let url = config.deleteDefaultTemplateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        template_code: e.template_code,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getDefaultTemplateList(true);
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDefaultTemplateList: function() {
      let url = config.getDefaultTemplateListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        template_code: this.templateCode
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.defaultTemplateList = response.data.dt;
                this.totalRow = this.defaultTemplateList.length > 0 ? this.defaultTemplateList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    addDefaultTemplate: function() {
      this.getDefaultTemplateList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_mini_game_template"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>